import React, { FC } from 'react';
import { PageTitle, PageLink } from '../../../_mexablock/layout/core';
import { View } from './components/View';

const breadCrumbs: Array<PageLink> = [];

const PreregistroPage: FC = () => {
  return (
    <>
      <PageTitle breadcrumbs={breadCrumbs}>Pre-registros</PageTitle>
      <View />
    </>
  );
};

export { PreregistroPage };
